/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
//import MsDyn365 from '@msdyn365-commerce/core';

import { ICusTermsOfServiceData } from './cus-terms-of-service.data';
import { ICusTermsOfServiceProps, ITermsData } from './cus-terms-of-service.props.autogenerated';

export interface ICusTermsOfServiceViewProps extends ICusTermsOfServiceProps<ICusTermsOfServiceData> {
    selectedTerms?: ITermsData;
}

/**
 *
 * CusTermsOfService component
 * @extends {React.PureComponent<ICusTermsOfServiceProps<ICusTermsOfServiceData>>}
 */
class CusTermsOfService extends React.PureComponent<ICusTermsOfServiceProps<ICusTermsOfServiceData>> {
    public render(): JSX.Element | null {
        var selectedTerms;
        const query = this.props.context.request.query;
        if (query) {
            selectedTerms = this.props.config.terms?.find(item => {
                return (
                    item.language.toLowerCase() === query['lang']?.toLowerCase() &&
                    item.country.toLowerCase() === query['country']?.toLowerCase()
                );
            });
        }

        if (!selectedTerms && this.props.config?.terms?.[0]) {
            selectedTerms = this.props.config?.terms?.[0];
        }

        const viewProps: ICusTermsOfServiceViewProps = { ...this.props, selectedTerms };
        return this.props.renderView(viewProps);
    }
}

export default CusTermsOfService;
